<template>
    <div id="bst-wrap">
        <div class="l-project-wrap">

            <Header :visibleSideMenu="false" />

            <!-- LABEL -->
<!--            <section class="l-label">-->
<!--                <div class="l-label__inner">-->
<!--                    <div class="l-label__btn">-->
<!--                        <div class="c-btn c-btn&#45;&#45;home"><a href="/" aria-label="home"></a></div>-->
<!--                    </div>-->
<!--                    <ul class="l-label__pankuzu">-->
<!--                        <li><a href="/">HOME</a></li>-->
<!--                        <li><span>{{ $t('TEXT_NOT_FOUND_PAGE_TITLE') }}</span></li>-->
<!--                    </ul>-->
<!--                </div>-->
<!--            </section>-->

            <section class="l-content-area">
                <div class="l-content">


                    <section class="p-bloc p-bloc--notfound">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner l-wrap__inner--notfound">
                                <h2>{{ $t('TEXT_NOT_FOUND_PAGE_TITLE') }}</h2>
                                <h3>{{ $t('TEXT_NOT_FOUND_PAGE_1') }}</h3>
                                <p>{{ $t('TEXT_NOT_FOUND_PAGE_2') }}<br>{{ $t('TEXT_NOT_FOUND_PAGE_3') }}</p>
                            </div>
                        </div>
                    </section><!-- .p-bloc .p-bloc--notfound -->


                </div><!-- .l-content -->

            </section><!-- .l-content-area -->

        </div><!-- .l-project-wrap -->

        <Footer />
    </div>
</template>

<script setup>

import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
</script>

<style lang="scss" scoped>
$color: red;
</style>